import React from "react";
import { Link } from "react-router-dom";

const HelpFAQ = () => {
  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Help & FAQ</h1> <hr />
      {/* FAQ Accordion */}
      <div className="accordion" id="faqAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
            >
              What is your refund policy?
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              We offer a full refund within 30 days of purchase if you are not
              satisfied with our service.
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
            >
              How can I contact customer support?
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              You can reach us via email at support@mahmoudosman.com or call us
              at +1 234 567 890.
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
            >
              Do you offer technical support?
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body">
              Yes, our technical support is available 24/7 via chat and email.
            </div>
          </div>
        </div>
      </div>
      {/* Contact Support */}
      <div className="card my-4">
        <div className="card-body text-center">
          <h5 className="card-title">Need More Help?</h5>
          <p className="card-text">
            If you have any additional questions, feel free to reach out to our
            support team.
          </p>
          <Link to="/api/get-in-touch/contact" className="btn btn-primary">
            Contact Support
          </Link>
        </div>
      </div>
      {/* Quick Links */}
      <div className="row text-center">
        <div className="col-md-4 mb-3">
          <a href="#" className="text-decoration-none">
            Privacy Policy
          </a>
        </div>
        <div className="col-md-4 mb-3">
          <a href="#" className="text-decoration-none">
            Terms of Service
          </a>
        </div>
        <div className="col-md-4 mb-3">
          <a href="#" className="text-decoration-none">
            Report an Issue
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpFAQ;
